import { render, staticRenderFns } from "./CoAdminAlert.vue?vue&type=template&id=4b467102&scoped=true&"
import script from "./CoAdminAlert.vue?vue&type=script&lang=ts&"
export * from "./CoAdminAlert.vue?vue&type=script&lang=ts&"
import style0 from "./CoAdminAlert.vue?vue&type=style&index=0&id=4b467102&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b467102",
  null
  
)

export default component.exports